module.exports = __webpack_public_path__ + "static/media/vegitables_13.86f87567.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_13.csv
// module id = 595
// module chunks = 0